<template>
    <div style="display: flex; flex-direction: column; align-items: center">
        <div style="margin: 28px">
            <span style="font-size: 22px">相关资料</span>
        </div>
        <div class="jxzb-table" style="width: 100%">
            <div style="text-align: right; padding: 10px">
                <span>
                    <el-button icon="el-icon-upload2" @click="opendialog">上传文件</el-button>
                    <el-button icon="el-icon-download" @click="todownload">批量下载</el-button>
                </span>
            </div>
            <!-- <el-table :data="tableData" :span-method="objectSpanMethod" border class="jxzb-tables"> -->
            <el-table ref="table" :data="tableData" border class="jxzb-tables" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" label="序号" width="50" align="center" />
                <el-table-column prop="flType" label="文件类型" width="150" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="fileNameType" label="文件名称" align="left" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="type !== 'attachment' && canEdit == 1" style="color: #42a5f5" @click="openwork(scope.row)">{{ scope.row.fileNameType }}</span>
                        <span v-else>{{ scope.row.fileNameType }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="fileSize" label="文件大小" width="150" align="center" :show-overflow-tooltip="true" />
                <el-table-column prop="flCreator" label="上传人" width="120" align="center" :show-overflow-tooltip="true" />
                <el-table-column prop="flCreateDate" label="上传时间" width="150" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ $moment(scope.row.flCreateDate).format('YYYY年MM月DD日') }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="type !== 'attachment' && canEdit == 1" label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="deleteload(scope.row)">删除</el-link>
                        <el-link type="primary" @click="todownload(scope.row)">下载</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog title="上传附件" :visible.sync="dialogVisible" width="824px">
                <el-form>
                    <div class="el-table el-table--fit el-table--border" style="width: 824px; margin-top: 10px">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                <tbody>
                                    <tr>
                                        <td class="el-table__cell tdlbl tdw17">
                                            <span class="required">*</span>
                                            文件类型
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <el-select v-model="fileType" placeholder="请选择">
                                                <el-option v-for="item in selOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                            </el-select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="el-table__cell tdlbl tdw17">
                                            <span class="required">*</span>
                                            上传文件
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <div class="row-col">
                                                <el-upload ref="upload" :on-change="handleUploadChange" action :multiple="false" :limit="1" :file-list="fileList" :show-file-list="true" :auto-upload="false" :on-remove="handleRemove">
                                                    <el-button slot="trigger" type="text">选择文件</el-button>
                                                </el-upload>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button :disabled="disBtn" @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" :disabled="disBtn" @click="toupload">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 0 },
        type: { type: String, default: 'detail' },
        wfEngineUrl: { type: String, default: null }
    },
    data() {
        return {
            tableData: [],
            multipleSelection: [],
            dialogVisible: false,
            selOptions: [
                { label: '工程造价', value: '工程造价' },
                { label: '管理责任协议', value: '管理责任协议' },
                { label: '咨询合同', value: '咨询合同' },
                { label: '进场手续', value: '进场手续' },
                { label: '招标(采购)文件', value: '招标(采购)文件' },
                { label: '质疑回复', value: '质疑回复' },
                { label: '中标通知书', value: '中标通知书' },
                { label: '投标文件', value: '投标文件' },
                { label: '报送资料', value: '报送资料' },
                { label: '工程量计算底稿', value: '工程量计算底稿' },
                { label: '三方定案表', value: '三方定案表' },
                { label: '成果关键页', value: '成果关键页' },
                { label: '成果文件', value: '成果文件' },
                { label: '成果报告', value: '成果报告' },
                { label: '评价表', value: '评价表' },
                { label: '其他', value: '其他' }
            ],
            fd: '',
            fileList: [],
            disBtn: false,
            fileType: '工程造价'
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {
        this.getList()
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        handleUploadChange(file) {
            console.log(file, 123123)
            this.fileList = []
            this.fd = ''
            const fd = new FormData()
            fd.append('file', file.raw)
            this.fd = fd
            this.fileList = [file]
        },
        handleRemove(file, fileList) {
            this.fileList = []
        },
        opendialog() {
            this.fileList = []
            this.dialogVisible = true
        },
        toupload() {
            if (!this.fileType) {
                this.$message.error('请选择文件类型')
                return
            }
            if (this.fileList.length === 0) {
                this.$message.error('请选择文件')
                return
            }
            this.disBtn = true
            const uploadId = this.vo.id
            this.fileList.forEach((item) => {
                const fd = new FormData()
                fd.append('file', item.raw)
                fd.append('module', 'zbxmArch')
                fd.append('busiDataId', uploadId)
                fd.append('attachsType', this.fileType)
                fd.append('clientType', 'uploader')
                fd.append('attachsName', item.name)
                fd.append('fileType', this.fileType)
                this.$http({
                    method: 'post',
                    url: 'zbgl/jggdItem/upload',
                    data: fd,
                    params: {
                        fileType: this.fileType
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.getList()
                        this.disBtn = false
                        this.dialogVisible = false
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        },
        getList() {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: { id: this.vo.id },
                url: 'zjgl/zjxmArch/getAttachListById'
            }).then(
                (response) => {
                    if (response.code === 'success') {
                        this.tableData = response.body.listdata
                    } else {
                        this.$message.error(response.message)
                    }
                },
                (err) => {
                    console.log(err)
                }
            )
        },
        deleteload(row) {
            console.log('🚀 ~ deleteload ~ row:', row)
            this.$confirm('您是否确认删除选择的数据?', '确认操作', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$http({
                        method: 'DELETE',
                        contentType: 'application/json charset=utf-8',
                        params: { attachIds: row.atttachId },
                        url: 'zjgl/zjxmArch/deleteAttach'
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message({ message: res.message, type: 'success' })
                            this.getList()
                        } else {
                            this.$alert(res.message, '提示', {
                                confirmButtonText: '确定',
                                type: 'warning'
                            })
                        }
                    })
                })
                .catch(() => {})
        },
        todownload(row) {
            console.log(this.multipleSelection, row.atttachId, 'this.multipleSelection')
            if (this.multipleSelection.length === 0 && row.atttachId === undefined) {
                return this.$message.error('请选择要下载的文件')
            }
            if (this.multipleSelection.length > 0) {
                const rowid = this.multipleSelection.map((item) => item.atttachId).join(',')
                window.open('apigw/zjgl/zjxmArch/downloadById?attachIds=' + rowid)
                this.$refs.table.clearSelection()
                this.multipleSelection = []
            } else {
                window.open('apigw/zjgl/zjxmArch/downloadById?attachIds=' + row.atttachId)
                this.$refs.table.clearSelection()
                this.multipleSelection = []
            }
        },
        openwork(row) {
            console.log('🚀 ~ openwork ~ row:', row)
            window.open('apigw/zjgl/zjxmArch/downloadById?attachIds=' + row.atttachId)
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';
</style>
